export default {
    data() {
        return {
            activeKey: ""
        };
    },
    mounted() {
        this.setActiveKey();
    },
    watch: {
        $route() {
            this.setActiveKey();
        }
    },
    computed: {
        openTab() {
            return this.$store.state.tabStore.openTab;
        },
    },
    methods: {
        tabChange(activeKey, type = "push") {
            if (this.$route.path != activeKey) {
                this.$router[type](activeKey);
            }
        },
        showClose(pane) {
            return pane.path == "/" ? false : true;
        },
        setActiveKey() {
            this.activeKey = this.$route.path;
        },
        editHandle(targetKey, action) {
            this[action](targetKey);
        },
        remove(targetKey) {
            if (targetKey == "/") {
                this.$message.error("首页不可删除");
                return;
            }
            let activeKey = this.activeKey;
            let lastIndex;
            this.openTab.forEach((pane, i) => {
                if (pane.path === targetKey) {
                    lastIndex = i - 1;
                }
            });
            const openTabData = this.openTab.filter(pane => pane.path !== targetKey);
            if (openTabData.length && activeKey === targetKey) {
                if (lastIndex >= 0) {
                    activeKey = openTabData[lastIndex].path;
                } else {
                    activeKey = openTabData[0].path;
                }
            }

            this.$store.commit("setOpenTab", openTabData);
            this.activeKey = activeKey;
            this.tabChange(this.activeKey);
        },
        dropdownClickHandle(data) {
            // 菜单点击
            this[data.key]();
        },
        closeAll() {
            // 关闭所有的页签
            const targetKey = "/";
            const openTabData = this.openTab.filter(pane => pane.path == targetKey);
            this.$store.commit("setOpenTab", openTabData);
            this.activeKey = targetKey;
            this.tabChange(this.activeKey);
        },
        closeCurrent() {
            // 删除当前页签
            const targetKey = this.activeKey;
            this.remove(targetKey);
        },
        closeOther() {
            // 删除其它页签
            const { activeKey } = this;
            const openTabData = this.openTab.filter(pane => pane.path == activeKey || pane.path == "/");
            this.$store.commit("setOpenTab", openTabData);
        }
    },
};